import React from "react";
import { connect } from "react-redux";
import { getServiceTypeList } from "../Actions/CommonAPI";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import MMPLShipCard from "./MMPLShipCard";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import DatePicker from "react-datepicker";
import FileSaver from "file-saver";
import Moment from "moment";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getShipSearchlist,
  getMMPLShipCount,
  getMMPLShipDeatil,
  exportToExcel,
} from "../Actions/MMPLDashboardAPI";
import CountUp from "react-countup";
import { AutoComplete } from "primereact/autocomplete";
import { Multiselect } from "multiselect-react-dropdown";
import MapCharts from "./Mapchart";
import axios from "axios";
import API from "../helpers/api";
import $ from "jquery";
import AddIcon from "../UIComponents/AddIcon";
import DoneIcon from "../Asset/done-icon.png";
import { toast } from "react-toastify";

let userrole = localStorage.getItem("UserRoles");
class MMPLDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDate: "",
      allShipo: 100,
      expiredShips: 99,
      expiringShips: 50,
      toDate: "",
      clientList: [],
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      filterTitle: "All Ships",
      action: 1,
      markers: [],
      searchShip: {
        IsClient: false,
        shipName: "",
        category: "",
        imoNo: "",
        client: "",
        serviceStatus: "",
        nextServiceDateFrom: "",
        nextServiceDateTo: "",
        pagesize: 25,
        pagenumber: 1,
        noofrecords: 2,
        ServiceTypes: [],
        isTotalShips: true,
        isOverdueShips: false,
        isShipsDue10: false,
        isShipsDue30: false,
        isShipsDue60: false,
        isShipsDue90: false,
        action: 1,
        status: "active",
        isShipSearch: false,
        isShoreSearch: false
      },
      shipData: {
        IsClient: false,
        mail: "",
        shipName: "",
      },
      inContract: false,
      notInContract: false,
      isBoth: true,
      isPopoveropen: false,
      selectedServiceTypes: [],
      EquipmentList: ["A_Equipment1", "B_Equipment2", "C_Equipment"],
      serviceType: [],
      PageNo: 1,
      tabs: [
        {
          tabName: "New",
          unique_id: `new1${(Math.random() + 1).toString(36).substring(7)}`,
          summernoteData: "",
          showInput: false
        }
      ],
      initialTabs: [
        {
          tabName: "New",
          unique_id: `new1${(Math.random() + 1).toString(36).substring(7)}`,
          summernoteData: "",
          showInput: false
        }
      ],
      deleteTabId: 0,
      deleteUniqueId: 0
    };
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onRemoveChange = this.onRemoveChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.GenerateReportData = this.GenerateReportData.bind(this);
    this.SearchMMPLData = this.SearchMMPLData.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onChangeClientName = this.onChangeClientName.bind(this);
  }

  componentDidMount() {
    const { dispatch, searchData, searched } = this.props;
    this.props.dispatch({ type: "ShowShipDetails", data: false });
    this.props.dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    let BothResult = localStorage.getItem("SearchBothContract");
    let ContractResult = localStorage.getItem("SearchCotract");
    if (BothResult !== "") {
      this.state.isBoth = JSON.parse(BothResult);
    }
    if (ContractResult === "false" && BothResult !== "true") {
      this.state.inContract = JSON.parse(ContractResult);
      this.state.notInContract = true;
    } else if (ContractResult !== "") {
      this.state.inContract = JSON.parse(ContractResult);
    }

    this.setState({}, () => {
      console.log(this.state.inContract, this.state.notInContract, this.state.isBoth)
    })
    dispatch(getMMPLShipCount(this.state.inContract, this.state.isBoth, ""));
    this.getClientList();
    if (searchData) {
      this.state.searchShip = searchData;
      this.state.searchShip.status = "active";
      if (searchData.ServiceTypes != "") {
        this.state.selectedServiceTypes = searchData.ServiceTypes.split(",");
      }
      if (searched !== true) {
        this.ClearSearchField("clear");
        dispatch({ type: "searchData", data: "" });
      }
    }
    this.setState({})
    dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, true));
    dispatch(getServiceTypeList());
    this.getMapInfo(this.state.inContract, this.state.isBoth);
    dispatch({ type: "searched", data: false });
    let searchitem = this.state.searchShip;
    let _this = this;
    $(document).keypress(function (event) {
      var keycode = event.keyCode || event.which;
      if (
        searchitem.shipName ||
        searchitem.client ||
        searchitem.imoNo ||
        searchitem.ServiceTypes.length > 0 ||
        searchitem.nextServiceDateFrom ||
        searchitem.nextServiceDateTo
      ) {
        if (keycode === 13) {
          _this.SearchMMPLData(1, 2, true);
        }
      }
    });

    $(document).on("click", ".equipment-service-pop-up-trigger", function () {
      var shipId = $(this).attr("data-shipId");
      _this.setState({
        equipmentServiceShipId: parseInt(shipId),
      }, () => {
        if (_this.state.equipmentServiceShipId) {
          _this.getShipNotes();
        }
        // dispatch(getShipEquipmentAndCategoryList({ EquipmentName: '', shipId: _this.state.equipmentServiceShipId, Category: '' }));
      });
    })

    $(document).on("blur", ".nav-tab-input", function () {
      let _tabs = _this.state.tabs;
      _tabs.forEach(ele => {
        ele['showInput'] = false;
      });
      _this.setState({
        tabs: _tabs
      });
    })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, searchData } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.searchShip));
    }

  }

  getShipDetails(action, isShipSearch = false, isShoreSearch = false) {
    const { dispatch } = this.props;
    // this.setState({ markers: [] })
    if (action === 1) {
      this.state.filterTitle = "All Ships";
      this.state.searchShip.isTotalShips = true;
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.setState({ action: 1 }, () => {
        this.SearchMMPLData(1, 2, true);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 2) {
      this.state.filterTitle = "Overdue Ships";
      this.state.searchShip.isTotalShips = false;
      this.state.searchShip.isOverdueShips = true;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 2 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 3) {
      this.state.filterTitle = "Ships Due in 10 Days";
      this.state.searchShip.isTotalShips = false;
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = true;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 3 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 4) {
      this.state.filterTitle = "Ships Due in 30 Days";
      this.state.searchShip.isTotalShips = false;
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = true;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 4 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 5) {
      this.state.filterTitle = "Ships Due in 60 Days";
      this.state.searchShip.isTotalShips = false;
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = true;
      this.state.searchShip.isShipsDue90 = false;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 5 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    } else if (action === 6) {
      this.state.filterTitle = "Ships Due in 90 Days";
      this.state.searchShip.isTotalShips = false;
      this.state.searchShip.isOverdueShips = false;
      this.state.searchShip.isShipsDue10 = false;
      this.state.searchShip.isShipsDue30 = false;
      this.state.searchShip.isShipsDue60 = false;
      this.state.searchShip.isShipsDue90 = true;
      this.state.searchShip.isShipSearch = isShipSearch;
      this.state.searchShip.isShoreSearch = isShoreSearch;
      this.setState({ action: 6 }, () => {
        this.SearchMMPLData(1, 2, false);
        this.ClearSearchField("cardClick");
      });
    }
    this.getMapInfo(this.state.inContract, this.state.isBoth);
  }

  onChangeClientName = (event, value) => {
    this.setState({
      searchShip: {
        ...this.state.searchShip,
        client: value,
      },
    });
  };
  getClientList = () => {
    let url = `${API.Clientlist}`;
    axios
      .get(url)
      .then((response) => {
        this.state.clientList = response.data.clients;
        this.setState({})
      })
      .catch((error) => {
        console.log(error);
      });
  };

  toggle = (target, item) => {
    this.state.inContract = this.state.inContract;
    this.state.isBoth = this.state.isBoth;
    this.state.notInContract = this.state.notInContract;
    this.state.isPopoveropen = !this.state.isPopoveropen;
    this.setState({

    });
  };
  handleRadioButtonChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "incontract") {
      this.state.inContract = true;
      this.state.notInContract = false;
      this.state.isBoth = false;
    }
    if (nodeName === "notcontract") {
      this.state.inContract = false;
      this.state.notInContract = true;
      this.state.isBoth = false;
    }
    if (nodeName === "both") {
      this.state.inContract = false;
      this.state.notInContract = false;
      this.state.isBoth = true;
    }
    this.setState({});
  };


  submitRequest = () => {
    const { dispatch } = this.props;
    localStorage.setItem("SearchCotract", this.state.inContract)
    localStorage.setItem("SearchBothContract", this.state.isBoth)
    dispatch(getMMPLShipCount(this.state.inContract, this.state.isBoth, ""));
    dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, true));
    this.getMapInfo(this.state.inContract, this.state.isBoth)
    this.state.isPopoveropen = !this.state.isPopoveropen;
    this.setState({})
  };


  handleFromDateChange(date) {
    this.state.searchShip.nextServiceDateFrom = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }

  handleToDateChange(date) {
    this.state.searchShip.nextServiceDateTo = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchShip[nodeName] = e.target.value;
    this.setState({});
  }

  serviceTypeChange(item, e) {
    let checked = [];
    checked = this.state.serviceType;
    if (e.target.checked) {
      checked.push({
        checkboxValue: item,
      });
      if (item === "Annual") {
        this.state.searchShip.Annually = true;
      } else if (item === "Biannual") {
        this.state.searchShip.Biannually = true;
      } else if (item === "Five yearly") {
        this.state.searchShip.FiveYearly = true;
      } else if (item === "Ten yearly") {
        this.state.searchShip.Tenyearly = true;
      }
    } else {
      const index = checked.findIndex((ch) => ch.checkboxValue === item);
      checked.splice(index, 1);
      if (item === "Annual") {
        this.state.searchShip.Annually = false;
      } else if (item === "Biannual") {
        this.state.searchShip.Biannually = false;
      } else if (item === "Five yearly") {
        this.state.searchShip.FiveYearly = false;
      } else if (item === "Ten yearly") {
        this.state.searchShip.Tenyearly = false;
      }
    }
    this.setState({ serviceType: checked });
    this.setState({});
  }

  suggestMItable(event) {
    let results = this.state.EquipmentList.filter((table) => {
      return table.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });

    this.setState({ EquipmentList: results });
  }

  GenerateReportData(contract, both) {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let URL = `${API.ShipReportAPI}?IsClient=${this.state.searchShip.IsClient}&status=${this.state.searchShip.status}&Mail=${user.email}&FliterByTotalShips=${this.state.searchShip.isTotalShips}&FliterByOverDue=${this.state.searchShip.isOverdueShips}&MMPLFliterByDueIn10Days=${this.state.searchShip.isShipsDue10}&FliterByDueIn30Days=${this.state.searchShip.isShipsDue30}&MMPLFliterByDueIn60Days=${this.state.searchShip.isShipsDue60}&FliterByDueIn90Days=${this.state.searchShip.isShipsDue90}&ShipName=${this.state.searchShip.shipName}&imo=${this.state.searchShip.imoNo}&MmplClientName=${this.state.searchShip.client}&MmplCategoryName=${this.state.searchShip.category}&ServiceTypes=${this.state.searchShip.ServiceTypes}&NextDueInFromDate=${this.state.searchShip.nextServiceDateFrom}&NextDueInToDate=${this.state.searchShip.nextServiceDateTo}&inContract=${contract}&isBoth=${both}&PageNumber=${this.state.searchShip.pagenumber}&PageSize=${this.state.searchShip.pagesize}`;
    axios
      .get(URL, { responseType: "blob" })
      .then((response) => {
        let blob = "";
        blob = new Blob([response.data], { type: response.data.type });
        FileSaver.saveAs(blob,
          "Ship report" + Moment().format("DD MM YYYY LT") + ".xlsx");
      })
      .catch((error) => {
        console.log(error);
      });
  }

  SearchMMPLData(pgno, noof, totalships) {
    const { dispatch } = this.props;
    const { searchShip, selectedServiceTypes } = this.state;
    searchShip["pagenumber"] = pgno;
    searchShip["noofrecords"] = noof;
    searchShip.ServiceTypes = selectedServiceTypes.join(",");
    this.setState(
      {
        searchShip: searchShip,
        filterShiplist: true,
      },
      () => {
        dispatch({ type: "searchData", data: this.state.searchShip })
        dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, totalships));
        this.setState({});
      }
    );
  }

  onSelectChange = (item) => {
    this.setState({ selectedServiceTypes: item });
  };

  onRemoveChange(item) {
    this.setState({ selectedServiceTypes: item });
  }

  ClearSearchField(type) {
    const { dispatch } = this.props;
    this.setState(
      {
        searchShip: {
          IsClient: false,
          shipName: "",
          category: "",
          imoNo: "",
          client: "",
          serviceStatus: "",
          nextServiceDateFrom: "",
          nextServiceDateTo: "",
          status: "active",
          noofrecords: 2,
          pagesize: 25,
          pagenumber: 1,
          ServiceTypes: [],
          isTotalShips: this.state.searchShip.isTotalShips,
          isOverdueShips: this.state.searchShip.isOverdueShips,
          isShipsDue10: this.state.searchShip.isShipsDue10,
          isShipsDue30: this.state.searchShip.isShipsDue30,
          isShipsDue60: this.state.searchShip.isShipsDue60,
          isShipsDue90: this.state.searchShip.isShipsDue90,
          action: this.state.searchShip.action,
          isShipSearch: this.state.searchShip.isShipSearch,
          isShoreSearch: this.state.searchShip.isShoreSearch,
        },
        EquipmentName: "",
        selectedServiceTypes: [],
      },
      () => {
        if (type !== "cardClick") {
          dispatch({ type: "searchData", data: "" });
          dispatch(getShipSearchlist(this.state.searchShip, this.state.inContract, this.state.isBoth, true));
        }

        this.state.selectedServiceTypes = []
        this.setState({});
      });
  }

  getMapInfo = (contract, both) => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let url = `${API.MapData}?isClient=${this.state.shipData.IsClient}&mail=${user.email}&inContract=${contract}&isBoth=${both}`;
    axios
      .get(url)
      .then((response) => {
        this.bindvalues(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  bindvalues = (data) => {
    const { action } = this.state;
    if (data.length !== 0) {
      let marker = [];
      data.map((item) => {
        if (action === 1) {
          if (item.isOverdue === true) {
            marker.push({
              ...item,
              markerColor: "#FF0000",
            });
          } else if (item.in10Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF5000",
            });
          } else if (item.in30Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF825A",
            });
          } else if (item.in60Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFA500",
            });
          } else if (item.in90Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFE000",
            });
          } else if (
            item.isOverdue === false &&
            item.in10Days === false &&
            item.in30Days === false &&
            item.in60Days === false &&
            item.in90Days === false
          ) {
            marker.push({
              ...item,
              markerColor: "#008800",
            });
          }
        } else if (action === 2 && item.isOverdue === true) {
          marker.push({
            ...item,
            markerColor: "#FF0000",
          });
        } else if (action === 3 && item.in10Days === true) {
          marker.push({
            ...item,
            markerColor: "#FF5000",
          });
        } else if (action === 4 && item.in30Days === true) {
          marker.push({
            ...item,
            markerColor: "#FF825A",
          });
        } else if (action === 5 && item.in60Days === true) {
          marker.push({
            ...item,
            markerColor: "#FFA500",
          });
        } else if (action === 6 && item.in90Days === true) {
          marker.push({
            ...item,
            markerColor: "#FFE000",
          });
        } else {
          if (item.isOverdue === true) {
            marker.push({
              ...item,
              markerColor: "#FF0000",
            });
          } else if (item.in10Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF5000",
            });
          } else if (item.in30Days === true) {
            marker.push({
              ...item,
              markerColor: "#FF825A",
            });
          } else if (item.in60Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFA500",
            });
          } else if (item.in90Days === true) {
            marker.push({
              ...item,
              markerColor: "#FFE000",
            });
          } else if (
            item.isOverdue === false &&
            item.in10Days === false &&
            item.in30Days === false &&
            item.in60Days === false &&
            item.in90Days === false
          ) {
            marker.push({
              ...item,
              markerColor: "#008800",
            });
          }
        }
      });
      if (action === 1) {
        marker = marker;
      } else if (action === 2) {
        marker = marker.filter((x) => x.isOverdue === true);
      } else if (action === 3) {
        marker = marker.filter((x) => x.in10Days === true);
      } else if (action === 4) {
        marker = marker.filter((x) => x.in30Days === true);
      } else if (action === 5) {
        marker = marker.filter((x) => x.in60Days === true);
      } else if (action === 6) {
        marker = marker.filter((x) => x.in90Days === true);
      } else {
        marker = marker;
      }
      this.setState({ markers: marker });
      console.log("Data", this.state.markers);
    } else {
      this.setState({ markers: [] });
    }
  };

  initiateSummerNote = () => {
    this.state.tabs.forEach(x => {
      $(`#summernote${x.unique_id}`).summernote({
        callbacks: {
          onInit: function () {
            var thisNote = $(this);
            if (thisNote.closest(".modal").length > 0) {
              thisNote.next().find(".dropdown-toggle").dropdown();
            }
          },
          onPaste: function (e) {
            var bufferText = (
              (e.originalEvent || e).clipboardData || window.clipboardData
            ).getData("text/html");
            e.preventDefault();
            var div = $("<div />");
            div.append(bufferText);
            div.find("*").each(function () {
              $(this).css("font-size", "12px");
              $(this).css("font-family", "Arial");
            });
            setTimeout(function () {
              document.execCommand("insertHtml", false, div.html());
            }, 10);
          },
        },
        tabsize: 2,
        height: "450px",
        fontSize: "12px",
        fontFamily: "Arial",
        toolbar: [
          ["style", ["style"]],
          ["font", ["bold", "underline", "clear"]],
          ["color", ["color"]],
          ["fontname", ["fontname"]],
          ["para", ["ul", "ol", "paragraph"]],
          ['table', ['table']],
          ['insert', ['picture']],
        ],
      });
      $(`#summernote${x.unique_id}`).css("font-size", "12px");
      $(`#summernote${x.unique_id}`).css("font-family", "Arial");
      $(`#summernote${x.unique_id}`).summernote('code', x.summernoteData);
    })

    $(".note-editable").css("font-size", "12px");
    $(".note-editable").css("font-family", "Arial");
    $(".close").attr("data-bs-dismiss", "modal");
    if ($('#noteTab .nav-link.active').length == 0)
      this.makeLastTabActive();
  }

  getShipNotes = () => {
    let shipNoteGetUrl = `${API.shipNotes}?shipId=${this.state.equipmentServiceShipId}`;
    let _tabs = [
      {
        tabName: "New",
        unique_id: `new1${(Math.random() + 1).toString(36).substring(7)}`,
        summernoteData: "",
        showInput: false
      }
    ]
    axios
      .get(shipNoteGetUrl)
      .then((response) => {
        if (response?.data?.shipNotes.length > 0) {
          _tabs = response.data.shipNotes.map(x => {
            return {
              tabName: x.name,
              unique_id: `new1${(Math.random() + 1).toString(36).substring(7)}`,
              summernoteData: x.data,
              showInput: false,
              tabId: x.tabId
            }
          });
        }
        this.setState({
          tabs: _tabs,
          initialTabs: _tabs
        }, () => this.initiateSummerNote());
      })
      .catch((error) => {
        console.log(error);
      });
  }

  postNotesData = () => {
    const { t } = this.props;
    let data = this.getSummerNoteData();
    let user = JSON.parse(localStorage.getItem("currentUser"));
    const _meta = {
      actionBy: user.email,
      shipId: this.state.equipmentServiceShipId,
      shipNotes: data.map(x => {
        return {
          tabId: x.tabId || 0, // 0 for creation
          name: x.tabName,
          data: x.summernoteData,
          dataDescription: x.summernoteData
        }
      })
    }
    let url = API.shipNotes;
    axios
      .post(url, _meta, {
        headers: {
          key: user.accessToken,
        },
      })
      .then((response) => {
        this.setState({
          initialTabs: data
        })
        toast.success(t('Toast.ShipNotes'), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // $('.planning-modal-lg').modal("toggle");
        // $(".modal-backdrop").remove();
      })
      .catch((error) => {
        console.error(error);
        toast.error(t('Toast.FailedNotes'), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  }

  addTab = () => {
    let tabs = this.state.tabs;
    let uni_id = `new${(Math.random() + 1).toString(36).substring(7)}`
    tabs = this.getSummerNoteData();
    tabs.push({
      tabName: `New`,
      unique_id: uni_id,
      summernoteData: "",
      showInput: false
    });
    this.setState({
      tabs: tabs
    }, () => this.initiateSummerNote())
  }

  handleInputBoxShow = (uniqueId, isShow) => {
    let tabs = this.state.tabs;
    let index = tabs.findIndex(x => x.unique_id == uniqueId);
    let item = tabs[index];
    item.showInput = isShow;
    tabs[index] = item;
    this.setState({
      tabs: tabs
    })
  }

  handleTabName = (e, uniqueId) => {
    let _tabs = this.state.tabs;
    let index = _tabs.findIndex(x => x.unique_id == uniqueId);
    let item = _tabs[index];
    item.tabName = e.target.value;
    _tabs[index] = item;
    this.setState({
      tabs: _tabs
    })
  }

  triggerDeleteConfirmationModel = (uniqueId, tabId) => {
    $('#delete-confirmation-modal').modal("toggle");
    this.setState({
      deleteTabId: tabId || 0,
      deleteUniqueId: uniqueId
    })
  }

  removeTab = (uniqueId, tabId) => {
    const { t } = this.props;
    let data = this.getSummerNoteData();
    let tabs = data.filter(x => x.unique_id != uniqueId);
    if (tabId) {
      let user = JSON.parse(localStorage.getItem("currentUser"));
      let shipNoteDeleteUrl = `${API.shipNotesDelete}?tabId=${tabId}&actionBy=${user.email}`;
      axios.delete(shipNoteDeleteUrl).then((response) => {
        toast.success(t('Toast.ShipNoteDelete'), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }).catch((error) => {
        console.log(error);
        toast.error(t('Toast.FailedDelNotes'), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
    }
    $('#delete-confirmation-modal').modal("toggle");
    // $(".modal-backdrop").remove();
    this.setState({
      tabs: tabs,
    }, () => this.makeLastTabActive())
  }

  getSummerNoteData = () => {
    return this.state.tabs.map(x => {
      return { ...x, 'summernoteData': $(`#summernote${x.unique_id}`).summernote("code") };
    })
  }

  makeLastTabActive = () => {
    $('#noteTab .nav-link').last().addClass("active").attr("aria-selected", "true");
    $(".summernote-wrapper.tab-pane.fade").last().addClass("active show");
  }

  triggerCloseMainModal = (closeClearModel) => {
    if (closeClearModel)
      $('#clear-confirmation-modal').modal("toggle");
    $('.planning-modal-lg').modal("toggle");
    $(".modal-backdrop").remove();
  }

  confirmationModal = () => {
    let data = this.getSummerNoteData();
    let isValid = true;
    if (this.state.initialTabs.length == data.length) {
      let validateArr = [];
      data.forEach((x, i) => {
        validateArr.push(this.comapareObject(this.state.initialTabs[i], x))
      });
      if (validateArr.indexOf(false) > -1)
        isValid = false;
    } else {
      isValid = false;
    }
    if (isValid)
      this.triggerCloseMainModal(false)
    else
      $('#clear-confirmation-modal').modal("toggle");
  }

  comapareObject = (obj1, obj2) => {
    let objEqual = false;
    const obj1Keys = Object.keys(obj1).sort();
    const obj2Keys = Object.keys(obj2).sort();
    if (obj1Keys.length !== obj2Keys.length) {
      return objEqual;
    } else {
      const areEqual = obj1Keys.every((key, index) => {
        const objValue1 = obj1[key];
        const objValue2 = obj2[obj2Keys[index]];
        return objValue1 === objValue2;
      });
      if (areEqual) {
        objEqual = true;
      }
      return objEqual;
    }
  }

  render() {
    const {
      mmplShipCount,
      mmplShipSearchResult,
      mmplShipInfo,
      showMMPLDetailsPane,
      serviceTypeList,
      t
    } = this.props;
    const {
      isTotalShips,
      isOverdueShips,
      isShipsDue10,
      isShipsDue30,
      isShipsDue60,
      isShipsDue90,
    } = this.state.searchShip;
    const { selectedServiceTypes } = this.state;
    return (
      <div className="full-height pt-3 m-3 ml-1">
        <div className="row">
          <div className={showMMPLDetailsPane ? "col-lg-4" : "col-lg-2"}>
            <div
              className={`${isTotalShips ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center`}
              onClick={() => this.getShipDetails(1)}
            >
              <h1>
                <CountUp
                  start={0}
                  end={mmplShipCount.total ? mmplShipCount.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h1>
              {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Total Ships</h6>
              ) : (
                <h5 className="text-center">Total Ships</h5>
              )} */? (
                  <h6 className="text-center">{t("content.totalship")}</h6>
                ) : (
                  <h5 className="text-center">{t("content.totalship")}</h5>
                )}
            </div>
          </div>

          <div className={showMMPLDetailsPane ? "col-lg-4" : "col-lg-2"}>
            <div
              className={`${isOverdueShips ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center pointer-default`}
            >
              <h3 style={{ color: "rgb(255, 0, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(2)}>
                <CountUp
                  start={0}
                  end={mmplShipCount.overDueCount?.total ? mmplShipCount.overDueCount?.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h3>
              {showMMPLDetailsPane/*  ? (
                <h6 className="text-center">Overdue Ships</h6>
              ) : (
                <h5 className="text-center">Overdue Ships</h5>
              )} */? (
                  <h6 className="text-center">{t("content.overdueship")}</h6>
                ) : (
                  <h6 className="text-center">{t("content.overdueship")}</h6>
                )}
              <div className="row mt-2">
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(2, true, false)}>{t('content.ship')}{" "}
                    <span style={{ color: "rgb(255, 0, 0)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.overDueCount?.ship ? mmplShipCount.overDueCount?.ship : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(2, false, true)}>{t('content.shore')}{" "}
                    <span style={{ color: "rgb(255, 0, 0)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.overDueCount?.shore ? mmplShipCount.overDueCount?.shore : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div className={showMMPLDetailsPane ? "col-lg-4" : "col-lg-2"}>
            <div
              className={`${isShipsDue10 ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center pointer-default`}

            >
              <h3 style={{ color: "rgb(255, 80, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(3)}>
                <CountUp
                  start={0}
                  end={mmplShipCount.in10DaysCount?.total ? mmplShipCount.in10DaysCount?.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h3>
              {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Ships Due in 10 Days</h6>
              ) : (
                <h5 className="text-center">Ships Due in 10 Days</h5>
              )} */? (
                  <h6 className="text-center">{t("content.10dayship")}</h6>
                ) : (
                  <h6 className="text-center">{t("content.10dayship")}</h6>
                )}
              <div className="row mt-2">
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(3, true, false)}>{t('content.ship')}{" "}
                    <span style={{ color: "rgb(255, 0, 0)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.in10DaysCount?.ship ? mmplShipCount.in10DaysCount?.ship : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(3, false, true)}>{t('content.shore')}{" "}
                    <span style={{ color: "rgb(255, 0, 0)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.in10DaysCount?.shore ? mmplShipCount.in10DaysCount?.shore : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div className={showMMPLDetailsPane ? "col-lg-4" : "col-lg-2"}>
            <div
              className={`${isShipsDue30 ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center pointer-default`}

            >
              <h3 style={{ color: "rgb(255, 130, 90)" }} className="pointer-cursor" onClick={() => this.getShipDetails(4)}>
                <CountUp
                  start={0}
                  end={mmplShipCount.in30DaysCount?.total ? mmplShipCount.in30DaysCount?.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h3>
              {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Ships Due in 30 Days</h6>
              ) : (
                <h5 className="text-center">Ships Due in 30 Days</h5>
              )} */ ? (
                  <h6 className="text-center">{t("content.30dayship")}</h6>
                ) : (
                  <h6 className="text-center">{t("content.30dayship")}</h6>
                )}
              <div className="row mt-2">
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(4, true, false)}>{t('content.ship')}{" "}
                    <span style={{ color: "rgb(255, 130, 90)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.in30DaysCount?.ship ? mmplShipCount.in30DaysCount?.ship : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(4, false, true)}>{t('content.shore')}{" "}
                    <span style={{ color: "rgb(255, 130, 90)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.in30DaysCount?.shore ? mmplShipCount.in30DaysCount?.shore : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div className={showMMPLDetailsPane ? "col-lg-4" : "col-lg-2"}>
            <div
              className={`${isShipsDue60 ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center pointer-default`}

            >
              <h3 style={{ color: "rgb(255, 165, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(5)}>
                <CountUp
                  start={0}
                  end={mmplShipCount.in60DaysCount?.total ? mmplShipCount.in60DaysCount?.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h3>
              {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Ships Due in 60 Days</h6>
              ) : (
                <h5 className="text-center">Ships Due in 60 Days</h5>
              )} */ ? (
                  <h6 className="text-center">{t("content.60dayship")}</h6>
                ) : (
                  <h6 className="text-center">{t("content.60dayship")}</h6>
                )}
              <div className="row mt-2">
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(5, true, false)}>{t('content.ship')}{" "}
                    <span style={{ color: "rgb(255, 165, 0)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.in60DaysCount?.ship ? mmplShipCount.in60DaysCount?.ship : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(5, false, true)}>{t('content.shore')}{" "}
                    <span style={{ color: "rgb(255, 165, 0)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.in60DaysCount?.shore ? mmplShipCount.in60DaysCount?.shore : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <div className={showMMPLDetailsPane ? "col-lg-4" : "col-lg-2"}>
            <div
              className={`${isShipsDue90 ? "active " : ""
                }card card-selector countcard mb2 p-2 text-center pointer-default`}
            >
              <h3 style={{ color: "rgb(255, 224, 0)" }} className="pointer-cursor" onClick={() => this.getShipDetails(6)}>
                <CountUp
                  start={0}
                  end={mmplShipCount.in90DaysCount?.total ? mmplShipCount.in90DaysCount?.total : 0}
                  duration={2.0}
                  separator=","
                />
              </h3>
              {showMMPLDetailsPane /* ? (
                <h6 className="text-center">Ships Due in 90 Days</h6>
              ) : (
                <h5 className="text-center">Ships Due in 90 Days</h5>
              )} */? (
                  <h6 className="text-center">{t('content.90dayship')}</h6>
                ) : (
                  <h6 className="text-center">{t('content.90dayship')}</h6>
                )}
              <div className="row mt-2">
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(6, true, false)}>{t('content.ship')}{" "}
                    <span style={{ color: "rgb(255, 224, 0)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.in90DaysCount?.ship ? mmplShipCount.in90DaysCount?.ship : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
                <div className="col-6">
                  <h6 className="text-nowrap pointer-cursor" onClick={() => this.getShipDetails(6, false, true)}>{t('content.shore')}{" "}
                    <span style={{ color: "rgb(255, 224, 0)" }}>
                      <CountUp
                        start={0}
                        end={mmplShipCount.in90DaysCount?.shore ? mmplShipCount.in90DaysCount?.shore : 0}
                        duration={2.0}
                        separator=","
                      />
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        {userrole === "admin" || userrole === "mmpl" || userrole === "approver" ? (
          <div className="row mt-3">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card MM-card-header"
                  style={{ backgroundColor: "white", border: "0px" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      {this.state.filterTitle === "All Ships" ? `${t("content.Allships")}` : this.state.filterTitle === "Overdue Ships" ? `${t("content.overdueship")}` : this.state.filterTitle === "Ships Due in 10 Days" ? `${t("content.10dayship")}` : this.state.filterTitle === "Ships Due in 30 Days" ?
                        `${t("content.30dayship")}` : this.state.filterTitle === "Ships Due in 60 Days" ? `${t("content.60dayship")}` : this.state.filterTitle === "Ships Due in 90 Days" ? `${t('content.90dayship')}` : ""}
                    </h5>
                  </div>
                </div>
                <div
                  style={{
                    height: "400px",
                    overflow: "auto",
                    position: "relative",
                  }}
                >
                  <MapCharts markers={this.state.markers} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card MM-card-header"
                style={{ backgroundColor: "white", border: "0px" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {this.state.filterTitle === "All Ships" ? `${t("content.Allships")}` : this.state.filterTitle === "Overdue Ships" ? `${t("content.overdueship")}` : this.state.filterTitle === "Ships Due in 10 Days" ? `${t("content.10dayship")}` : this.state.filterTitle === "Ships Due in 30 Days" ?
                      `${t("content.30dayship")}` : this.state.filterTitle === "Ships Due in 60 Days" ? `${t("content.60dayship")}` : this.state.filterTitle === "Ships Due in 90 Days" ? `${t('content.90dayship')}` : ""}
                  </h5>
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row">
                  <div
                    className={showMMPLDetailsPane ? "col-lg-6 " : "col-lg-4 "}
                  >
                    <label className="form-label">{t('content.Shipname')}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="shipName"
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchShip.shipName}
                      placeholder={t('content.Shipname')}
                    ></input>
                    {/* <AutoComplete value={this.state.shipName} onChange={(e) => this.handleInputChange(e)}
                      suggestions={this.state.EquipmentList} completeMethod={this.suggestMItable.bind(this)}
                      name="shipName" inputClassName="form-control" placeholder="Ship Name" style={{ display: 'block' }}
                      inputStyle={!showMMPLDetailsPane ? { borderColor: "#ced4da", height: "38px" } : { borderColor: "#ced4da", width: '270.75px', height: '38px' }} /> */}
                  </div>
                  <div
                    className={showMMPLDetailsPane ? "col-lg-6 " : "col-lg-4 "}
                  >
                    <label className="form-label">{t('content.Client')}</label>
                    <br></br>
                    <Autocomplete
                      value={this.state.searchShip.client}
                      options={this.state.clientList}
                      getOptionLabel={(option) => option || ""}
                      onChange={(event, value) => {
                        this.onChangeClientName(event, value);
                      }}
                      noOptionsText={"No options to display"}
                      freeSolo={false}
                      disableClearable
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="form-control"
                          id="margin-dense"
                          style={{ marginTop: -1 }}
                          margin="dense"
                          size="small"
                          variant="outlined"
                          placeholder={t('content.Client')}
                        />
                      )}
                    />

                  </div>
                  <div
                    className={showMMPLDetailsPane ? "col-lg-6 " : "col-lg-4 "}
                  >
                    <label className="form-label">{t('content.IMOno')}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="imoNo"
                      placeholder={t('content.IMOno')}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchShip.imoNo}
                    ></input>
                  </div>
                  <div
                    className={showMMPLDetailsPane ? "col-lg-6 " : "col-lg-4 "}
                  >
                    <label className="form-label">{t('content.Servicetype')}</label>
                    <Multiselect
                      options={serviceTypeList ?? []}
                      showArrow={true}
                      isObject={false}
                      style={{
                        option: {
                          marginRight: 0,
                          display: "block",
                          fontWeight: "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.onSelectChange(item)}
                      onRemove={(item) => this.onRemoveChange(item)}
                      selectedValues={selectedServiceTypes}
                      placeholder={
                        this.state.selectedServiceTypes &&
                          this.state.selectedServiceTypes.length
                          ? ""
                          : `${t('content.Select')}`
                      }
                      closeIcon="cancel"
                    />
                    {/* <div className="row">
                      <div className={showMMPLDetailsPane ? "row ml-0" : "col-sm-12 flex flexwrap"}>
                        <div className={showMMPLDetailsPane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Annual').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Annual')}></input>
                          <span className="ml-1">Annual</span>
                        </div>
                        <div className={showMMPLDetailsPane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Biannual').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Biannual')}></input>
                          <span className="ml-1">Biannual</span>
                        </div>
                        <div className={showMMPLDetailsPane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Five yearly').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Five yearly')}></input>
                          <span className="ml-1">Five Yearly</span>
                        </div>
                        <div className={showMMPLDetailsPane ? "col-sm-6" : ""}>
                          <input type="checkbox" checked={serviceType.length != 0 ? (serviceType.filter(e => e.checkboxValue == 'Ten yearly').length != 0 ? true : false) : false} onChange={this.serviceTypeChange.bind(this, 'Ten yearly')}></input>
                          <span className="ml-1">Ten Yearly</span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div
                    className={
                      showMMPLDetailsPane
                        ? "col-lg-6  col-sm-12 col-xs-12"
                        : "col-lg-4  col-sm-12 col-xs-12"
                    }
                  >
                    {/* <label className="form-label">Next Due In</label>
                      <br></br> */}
                    <div className="row">
                      <div
                        className={
                          showMMPLDetailsPane ? "col-lg-6" : "col-lg-6"
                        }
                      >
                        <label className="form-label">{t('content.NextDueFrom')}</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.searchShip.nextServiceDateFrom}
                            className="form-control date-picker"
                            placeholder={t('content.NextDueFrom')}
                            name="fromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control date-picker w-5 hide-date"
                          // maxDate={this.state.SelectedToDate}
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button
                              className="btn btn-default"
                              style={{ height: "100%" }}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          showMMPLDetailsPane
                            ? "col-lg-6 margin"
                            : "col-lg-6 margin"
                        }
                      >
                        <label className="form-label">{t('content.NextDueTo')}</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.searchShip.nextServiceDateTo}
                            type="text"
                            placeholder={t('content.NextDueTo')}
                            className="form-control date-picker"
                            name="toDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          // minDate={this.state.SelectedFromDate}
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openToDatePicker}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className={
                      showMMPLDetailsPane ? "col-sm-12 mt-4" : "col-lg-12 mt-4"
                    }>
                    <div
                      className="form-group search-btn-col"
                      style={{ textAlign: "end" }}>
                      {/* <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        id="popover">
                        {" "}
                        {t('ShipManagementContent.Contract')}{" "}
                      </button>

                      <Popover
                        className="popover-master"
                        placement="left"
                        trigger="legacy"
                        isOpen={this.state.isPopoveropen}
                        target={"popover"}
                        toggle={() => this.toggle()}>
                        <PopoverHeader>
                          Contract Search
                        </PopoverHeader>
                        <PopoverBody>
                          <div className="row">
                            <div className="col-4 my-1 d-flex">
                              <input
                                type="radio"
                                name="incontract"
                                checked={this.state.inContract}
                                onChange={(e) =>
                                  this.handleRadioButtonChange(e)
                                }
                              />
                              <span className="ml-1">{t("ContractContent.IsContract")}</span>
                            </div>
                            <div className="col-5 my-1 d-flex">
                              <input
                                type="radio"
                                name="notcontract"
                                checked={this.state.notInContract}
                                onChange={(e) =>
                                  this.handleRadioButtonChange(e)
                                }
                              />
                              <span className="ml-1">{t("ContractContent.NotContract")}</span>
                            </div>
                            <div className="col-3 my-1 d-flex">
                              <input
                                type="radio"
                                name="both"
                                checked={this.state.isBoth}
                                onChange={(e) =>
                                  this.handleRadioButtonChange(e)
                                }
                              />
                              <span className="ml-1">{t("ContractContent.All")}</span>
                            </div>
                            <div
                              className="col-12 mt-1"
                              style={{ textAlign: "right" }}
                            >
                              <div className="btn-group">
                                <Button
                                  className="btn btn-primary btn-xs mt-2"
                                  size="sm"
                                  onClick={() => this.submitRequest()}
                                >
                                  {t("Generateservicerequestcontent.Request")}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </PopoverBody>
                      </Popover> */}
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                        type="submit"
                        onClick={() => this.GenerateReportData(this.state.inContract, this.state.isBoth)}
                      >
                        {" "}
                        {t('content.GenerateReport')}{" "}
                      </button>

                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                        type="submit"
                        onClick={() => this.SearchMMPLData(1, 2, true)}
                      >
                        {" "}
                        {t('content.Search')}{" "}
                      </button>

                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.ClearSearchField("clear")}
                      >
                        {" "}
                        {t('content.Clear')}{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {mmplShipSearchResult ? (
          <MMPLShipCard
            arraylist={mmplShipSearchResult}
            pageSize={mmplShipSearchResult.pagination.pageSize}
            totalRecords={
              mmplShipSearchResult.pagination.totalcount
                ? mmplShipSearchResult.pagination.totalcount
                : 0
            }
            setUpdatedState={(value, records) => this.SearchMMPLData(value, records, true)}
            shipMMPLInfo={mmplShipInfo}
            isContract={this.state.inContract}
            isBoth={this.state.isBoth}
          />
        ) : null}

        <div
          className="modal fade planning-modal-lg"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
          data-backdrop="static"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="full-height container-fluid pt-3">
                <div className="row mt-2">
                  <div className="col-lg-12">
                    <div className="panel-box">
                      <div
                        className="card MM-card-header"
                        style={{ backgroundColor: "white" }}
                      >
                        <div className="card-body">
                          <h5
                            className="card-title ml-2 mt-2"
                            style={{ color: "092a51" }}
                          >
                            {t("TopPaneContent.EquipmentReport")}
                            <button type="button" className="close" onClick={() => this.confirmationModal()} /* data-dismiss="modal" aria-label="Close" aria-hidden="true" data-bs-dismiss="modal" */>×</button>
                          </h5>
                        </div>
                      </div>
                      <div className="search-filter-box">
                        {/* <div className="row">
                          <div
                            className={"col-lg-3"}
                          >
                            <div className="">
                              <label className="form-label">{t("ShipEquipmentStatusScreen.Equipment")}</label>
                              <br></br>
                              <Autocomplete
                                // value={this.state.searchShip.client}
                                options={EquipmentNameList || []}
                                getOptionLabel={(option) => option.equipmentName || ""}
                                onChange={(event, value) => {
                                  this.handleChangeEquipmentName(event, value);
                                }}
                                noOptionsText={"No options to display"}
                                freeSolo={false}
                                disableClearable
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    className="form-control"
                                    id="margin-dense"
                                    style={{ marginTop: -1 }}
                                    margin="dense"
                                    size="small"
                                    variant="outlined"
                                    placeholder={t("ShipEquipmentStatusScreen.Equipment")}
                                  />
                                )}
                              />
                            </div>

                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("ShipDetailsScreen.NextDue")}</label>
                            <br></br>
                            // <div>
                            <input
                              className="form-control"
                              type="text"
                              name="shipName"
                              disabled={true}
                              value={this.state.searchShip.shipName}
                              placeholder={t("ShipDetailsScreen.NextDue")}
                            ></input>
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("ComplianceandBudgetScreen.Type")}</label>
                            <input
                              className="form-control"
                              type="text"
                              name="type"
                              disabled={true}
                              value={this.state.searchShip.shipName}
                              placeholder={t("ComplianceandBudgetScreen.Type")}
                            ></input>
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("TopPaneContent.PerformedBy")}</label>
                            <input
                              className="form-control"
                              type="text"
                              name="shipName"
                              disabled={true}
                              value={this.state.searchShip.shipName}
                              placeholder={t("TopPaneContent.PerformedBy")}
                            ></input>
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("EquipmentServiceTypes.Country")}</label>
                            <Autocomplete
                              // value={this.state.searchShip.client}
                              options={CountryList?.data || []}
                              getOptionLabel={(option) => option.country || ""}
                              // onChange={(event, value) => {
                              //   this.handleChangeClientName(event, value);
                              // }}
                              noOptionsText={"No options to display"}
                              freeSolo={false}
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="form-control"
                                  id="margin-dense"
                                  style={{ marginTop: -1 }}
                                  margin="dense"
                                  size="small"
                                  variant="outlined"
                                  placeholder={t("EquipmentServiceTypes.Country")}
                                />
                              )}
                            />
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("TopPaneContent.Port")}</label>
                            <Autocomplete
                              // value={this.state.searchShip.client}
                              options={PortList?.data || []}
                              getOptionLabel={(option) => option.port || ""}
                              // onChange={(event, value) => {
                              //   this.handleChangeClientName(event, value);
                              // }}
                              noOptionsText={"No options to display"}
                              freeSolo={false}
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="form-control"
                                  id="margin-dense"
                                  style={{ marginTop: -1 }}
                                  margin="dense"
                                  size="small"
                                  variant="outlined"
                                  placeholder={t("TopPaneContent.Port")}
                                />
                              )}
                            />
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("ShipDetailsScreen.ServiceProvider")}</label>
                            <Autocomplete
                              // value={this.state.searchShip.client}
                              options={ServiceProviderPortList?.data || []}
                              getOptionLabel={(option) => option.serviceProvider || ""}
                              // onChange={(event, value) => {
                              //   this.handleChangeClientName(event, value);
                              // }}
                              noOptionsText={"No options to display"}
                              freeSolo={false}
                              disableClearable
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="form-control"
                                  id="margin-dense"
                                  style={{ marginTop: -1 }}
                                  margin="dense"
                                  size="small"
                                  variant="outlined"
                                  placeholder={t("ShipDetailsScreen.ServiceProvider")}
                                />
                              )}
                            />
                          </div>
                          <div
                            className={"col-lg-3"}
                          >
                            <label className="form-label">{t("ShipDetailsScreen.Comments")}</label>
                            <textarea
                              className="form-control"
                              id="comments"
                              name="comments"
                              rows={1}
                            ></textarea>
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-12">
                            <div className="equipment-service-note-tab-wrapper">
                              <ul className="nav nav-tabs" id="noteTab" role="tablist">
                                {
                                  this.state.tabs.map((ele, ind) => {
                                    return <li className="nav-item" role="presentation">
                                      <button
                                        className={`nav-link`}
                                        id={ele.unique_id + '-tab'}
                                        data-toggle="tab"
                                        data-target={`#${ele.unique_id}`}
                                        type="button"
                                        role="tab"
                                        aria-controls={`${ele.unique_id}`}
                                        aria-selected='false'
                                      // onClick={() => this.initiateSummerNote(`${ele.unique_id}`)}
                                      >
                                        {
                                          ele.showInput ? <div className="d-flex">
                                            <input type="text" className="form-control nav-tab-input" autoFocus="true" value={ele.tabName} autoComplete="off" onChange={(e) => this.handleTabName(e, ele.unique_id)}></input>
                                            <img className="nav-tab-input-img" style={{ height: '1.2rem' }} onClick={() => this.handleInputBoxShow(ele.unique_id, false)} src={DoneIcon}></img>
                                            {/* <img className="nav-tab-input-img" style={{ height: '1.4rem' }} src={CloseIcon}></img> */}
                                          </div> :
                                            <span>{ele.tabName == "New" ? `${ele.tabName} ${ind + 1}` : ele.tabName}{" "}</span>
                                        }
                                        {
                                          !ele.showInput ? <i className="fa fa-edit m-1 ml-3" onClick={() => this.handleInputBoxShow(ele.unique_id, true)}></i> : ''
                                        }
                                        <i class="fa fa-times m-1" onClick={() => this.triggerDeleteConfirmationModel(ele.unique_id, ele.tabId)}></i>
                                      </button>
                                    </li>
                                  })
                                }
                                <div className="tab-add" onClick={() => this.addTab()}>
                                  <AddIcon />
                                </div>
                              </ul>
                            </div>

                            <div className="tab-content" id="myTabContent">
                              {
                                this.state.tabs.map((ele, ind) => {
                                  return <div
                                    className={`summernote-wrapper tab-pane fade`}
                                    id={ele.unique_id}
                                    role="tabpanel"
                                    aria-labelledby={`${ele.unique_id}-tab`}
                                  >
                                    <div className="pt-2" id={`summernote${ele.unique_id}`}></div>
                                  </div>
                                })
                              }
                            </div>
                          </div>

                        </div>
                        <div className="row">
                          <div
                            className={"col-sm-12"}
                          >
                            <div
                              className="form-group search-btn-col mt-3"
                              style={{ textAlign: "end" }}
                            >
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.postNotesData()}
                              >
                                {" "}
                                {t("EditEquipmentScreenContent.Save")}{" "}
                              </button>

                              <button
                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3 close"
                                type="button" /* data-dismiss="modal" aria-label="Close" aria-hidden="true" data-bs-dismiss="modal" */
                                onClick={() => this.confirmationModal()}
                              >
                                {" "}
                                {t("EditEquipmentScreenContent.Close")}{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="panel-box">
                      <div className="search-filter-box">
                        <table className="table equipment-report-table border-0">
                          <thead className="">
                            <tr>
                              <th scope="col">{t("ShipEquipmentStatusScreen.Equipment")}</th>
                              <th scope="col">{t("ShipDetailsScreen.NextDue")}</th>
                              <th scope="col">{t("ComplianceandBudgetScreen.Type")}</th>
                              <th scope="col">{t("TopPaneContent.PerformedBy")}</th>
                              <th scope="col">{t("EquipmentServiceTypes.Country")}</th>
                              <th scope="col">{t("TopPaneContent.Port")}</th>
                              <th scope="col">{t("ShipDetailsScreen.ServiceProvider")}</th>
                              <th scope="col" style={{ width: "30%" }}>{t("ShipDetailsScreen.Comments")}</th>
                              <th scope="col">{t("VendorManagementScreenContent.Action")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Alcohol Meter</td>
                              <td>29 Sep 2024</td>
                              <td>1 yearly</td>
                              <td>Ship</td>
                              <td>Okha</td>
                              <td>India</td>
                              <td>Ask marine service</td>
                              <td>He made his comments at a news conference in Amsterdam.</td>
                              <td><div className="text-center">
                                <i
                                  className="fa fa-edit fa-lg click m-1 px-1"
                                  // onClick={() =>
                                  //   this.showFlagModal(
                                  //     item.Id,
                                  //     false,
                                  //     item.equipmentId
                                  //   )
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                                <i
                                  className="fa fa-trash click m-1 px-2"
                                  // onClick={() =>
                                  //   this.deleteApplicableType(index)
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                              </div></td>
                            </tr>
                            <tr>
                              <td>Breathing Air Compressor (Air Quality Check)</td>
                              <td>11 Sep 2024</td>
                              <td>4 yearly</td>
                              <td>Shore</td>
                              <td>Okha</td>
                              <td>India</td>
                              <td>Ask marine service</td>
                              <td>I was wondering whether you had any comments about that?</td>
                              <td><div className="text-center">
                                <i
                                  className="fa fa-edit fa-lg click m-1 px-1"
                                  // onClick={() =>
                                  //   this.showFlagModal(
                                  //     item.Id,
                                  //     false,
                                  //     item.equipmentId
                                  //   )
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                                <i
                                  className="fa fa-trash click m-1 px-2"
                                  // onClick={() =>
                                  //   this.deleteApplicableType(index)
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                              </div></td>
                            </tr>
                            <tr>
                              <td>Emergency Escape Breathing Device</td>
                              <td>11 Sep 2024</td>
                              <td>5 yearly</td>
                              <td>Ship</td>
                              <td>Okha</td>
                              <td>India</td>
                              <td>Ask marine service</td>
                              <td>There's been no comment so far from police about the allegations.</td>
                              <td><div className="text-center">
                                <i
                                  className="fa fa-edit fa-lg click m-1 px-1"
                                  // onClick={() =>
                                  //   this.showFlagModal(
                                  //     item.Id,
                                  //     false,
                                  //     item.equipmentId
                                  //   )
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                                <i
                                  className="fa fa-trash click m-1 px-2"
                                  // onClick={() =>
                                  //   this.deleteApplicableType(index)
                                  // }
                                  aria-hidden="true"
                                  style={{
                                    color: " #1a3464",
                                    fontSize: "1.8rem",
                                  }}
                                ></i>
                              </div></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Delete confirmation model */}
        <div
          className="modal fade"
          id="delete-confirmation-modal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="delete-confirmation-modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="delete-confirmation-modalLabel">
                  {t("CommonText.Delete")}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{t("confirmAlertMessage.DeleteMsg")}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light text-uppercase txtside-btn txtht-btn"
                  data-dismiss="modal"
                >
                  {t("confirmAlertMessage.No")}
                </button>
                <button type="button" onClick={() => this.removeTab(this.state.deleteUniqueId, this.state.deleteTabId)} className="btn btn-primary text-uppercase txtside-btn txtht-btn blue">
                  {t("confirmAlertMessage.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Clear confirmation modal */}
        <div
          className="modal fade"
          id="clear-confirmation-modal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="clear-confirmation-modalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="clear-confirmation-modalLabel">
                  {t("confirmAlertMessage.Warning")}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{t("confirmAlertMessage.ClearMsg")}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light text-uppercase txtside-btn txtht-btn"
                  data-dismiss="modal"
                >
                  {t("confirmAlertMessage.No")}
                </button>
                <button type="button" onClick={() => this.triggerCloseMainModal(true)} className="btn btn-primary text-uppercase txtside-btn txtht-btn blue">
                  {t("confirmAlertMessage.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    materialDeclarationslist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    searchData: state.SidePanReducer.searchData,
    searched: state.SidePanReducer.searched || false,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    //BY BALU MOORTHI
    mmplShipCount: state.MMPLDashboardReducer.MMPLShipCount || {
      total: 0,
      overDue: 0,
      in10Days: 0,
      in30Days: 0,
      in60Days: 0,
      in90Days: 0,
    },
    mmplShipDetail: state.MMPLDashboardReducer.MMPLShipDetail || {},
    mmplShipSearchResult: state.MMPLDashboardReducer.MMPLShipSearchResult || null,
    mmplShipInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetailsPane || false,
    serviceTypeList: state.MasterScreenReducer.applicableServiceTypeInterval || [],
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MMPLDashboard));
